export const CLASS_NAMES = {
  container:
    'py-5 md:px-4 flex flex-row md:border border-neutral-300 rounded-lg mb-4 justify-between md:justify-start md:shadow-none',
  text: 'flex flex-col',
  title: 'text-14-22-em text-neutral-900',
  subtitle: 'text-12-18 text-neutral-600',
};
